<script setup lang="ts">
  import { useLocale } from '@tundr/i18n';
  import { computed } from 'vue';
  import { InfoTooltip } from '../InfoTooltip';

  const props = defineProps<{
    label: string;
    info: string;
    testId: string;
  }>();

  const { t } = useLocale('ds-components');

  const ariaLabel = computed(() =>
    t('attribute.info_aria_label', { label: props.label }),
  );
</script>

<template>
  <InfoTooltip :description="info" :aria-label="ariaLabel" :test-id="testId" />
</template>
